import { render, staticRenderFns } from "./view_loader.vue?vue&type=template&id=0c36e85b&scoped=true"
import script from "./view_loader.vue?vue&type=script&lang=js"
export * from "./view_loader.vue?vue&type=script&lang=js"
import style0 from "./view_loader.vue?vue&type=style&index=0&id=0c36e85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36e85b",
  null
  
)

export default component.exports